import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IModulo } from './modulo';
import { catchError, tap, map } from 'rxjs/operators';
import * as myGlobals from './../global';
import { HttpClientSecured } from '../services/http-client-secured';

@Injectable({
  providedIn: 'root'
})
export class ModulosService {
  private modulosURL = myGlobals.baseApi + '/api/modulos/indexjoin';
  constructor(private http: HttpClientSecured) {}

  getModulos(): Observable<IModulo[]> {
    return this.http.get<IModulo[]>(this.modulosURL).pipe(
      tap(data => console.log('All Modulos: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

  getModulo(id: number): Observable<IModulo | undefined> {
    return this.getModulos().pipe(map((modulos: IModulo[]) => modulos.find(p => p.id === id)));
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
